import React, {useState, useContext} from 'react';
import {useParams} from 'react-router-dom';
import {DateRange} from 'react-date-range';

import AuditContext from '../Utils/context.js';
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'

export default function Visitation() {

  const {employeeId} = useParams();
  const {schedule} = useContext(AuditContext);

  const [state, setState] = useState([
    {
      startDate: new Date(schedule.START_DATE),
      endDate: new Date(schedule.END_DATE),
      key: 'selection'
    }
  ]);

  return (
    <div>
      <DateRange
        onChange={item => setState([item.selection])}
        moveRangeOnFirstSelection={false}
        ranges={state}
        months={2}
        disabled={true}
        direction="horizontal"
      />
    </div>
  );
}